import { Document, Page, View, StyleSheet, Text, Image, Font } from "@react-pdf/renderer";
import srcHanSans from '../../../assets/custom/font/china_han/Source_Han_Sans_CN_Light.otf';
import srcHanBold from '../../../assets/custom/font/china_han/Source_Han_Sans_CN_Bold.otf';
import { useCallback, useEffect, useMemo, useState } from "react";
import TransaksiService from "../../../services/transaksi/TransaksiService";
import UserService from "../../../services/user/UserService";
import MasterService from "../../../services/master/MasterService";
import { formatDateStringLocalDate, formatNumberUSFormat } from "../../../utilities/Utils";
import imgCheckBoxOutline from "../../../assets/images/icons/checkbox_blank_outline_icon.png";
import imgCheckBoxIcon from "../../../assets/images/icons/checkbox_icon.png";
import KotaKab from "../../../utilities/KotaKab";
import DraftAppendix from "../draft/DraftAppendix";
import Propinsi from "../../../utilities/Propinsi";
import Kemasan from "../../../utilities/Kemasan";

Font.register({ family: 'Source Han Sans CN Light', src: srcHanSans })
Font.register({ family: 'Source Han Sans CN Bold', src: srcHanBold })

const styles = StyleSheet.create({
    page: {
        paddingTop: 210,
        paddingBottom: 48,
        paddingHorizontal: 48,
        boxSizing: "border-box"
    },
    pageTwo: {
        paddingTop: 20,
        paddingBottom: 48,
        paddingHorizontal: 48,
        boxSizing: "border-box"
    },
    headingImg: {
        width: 50,
        height: 50,
        marginVertical: 15,
        marginHorizontal: 235,
    },
    headingCn: {
        fontFamily: "Source Han Sans CN Bold",
        fontSize: 8,
        textAlign: "center",
    },
    headingEn: {
        fontSize: 8,
        textAlign: "center",
        marginBottom: 3
    },
    table: {
        border: '1 solid black',
        display: 'table',
        width: 'auto',
    },
    tableCon1: {
        borderBottom: '1 solid black',
        borderRight: '1 solid black',
        borderLeft: '1 solid black',
        display: 'table',
        width: '50%',
    },
    tableCon2: {
        borderBottom: '1 solid black',
        borderRight: '1 solid black',
        display: 'table',
        width: '50%',
    },
    tableRow: {
        flexDirection: 'row',
    },
    tableColBox1: {
        width: '35%',
        padding: 2,
        textAlign: 'left',
    },
    tableColBox2: {
        width: '3%',
        padding: 2,
        textAlign: 'left',
    },
    tableColBox3: {
        width: '55%',
        padding: 5,
        textAlign: 'left',
    },
    tableColBoxAtt: {
        width: '95%',
        textAlign: "justify"
    },
    textRefNoCn: {
        fontFamily: "Source Han Sans CN Light",
        fontSize: 7,
        textAlign: "left",
        marginRight: 75
    },
    textRefNo: {
        fontFamily: "Source Han Sans CN Light",
        fontSize: 7,
        textAlign: "right",
        marginRight: 75
    },
    textCnBold: {
        fontFamily: "Source Han Sans CN Bold",
        fontSize: 9,
        textAlign: "left",
        padding: 3
    },
    textCn: {
        fontFamily: "Source Han Sans CN Light",
        fontSize: 8,
        textAlign: "left",
        padding: 3
    },
    textCnAtt: {
        fontFamily: "Source Han Sans CN Light",
        fontSize: 7.3,
        textAlign: "left",
        padding: 3
    },
    textEn: {
        fontSize: 7,
        textAlign: "left",
        padding: 3
    },
    textIn: {
        fontFamily: "Roboto-Italic",
        fontSize: 7,
        textAlign: "left",
        padding: 3
    },
    checkicon:
    {
        width: 12,
        height: 12
    },
    sectionHeader: {
        paddingTop: 0, // tidak ada padding dinamis
        marginBottom: 0
    }
})

const FormB = ({ dataDisposisi, datappm, qrImage }) => {
    let transaksiService = useMemo(() => new TransaksiService(), [])
    let userService = useMemo(() => new UserService(), [])
    let masterService = useMemo(() => new MasterService(), [])

    const [dataHc, setDataHc] = useState(null)
    const [upt, setUpt] = useState(null)
    const [negaraTujuan, setNegaraTujuan] = useState(null)
    const [pelMuat, setPelMuat] = useState(null)
    const [pelBongkar, setPelBongkar] = useState(null)
    const [ppmDetil, setPpmDetil] = useState([])
    const [totalJumlah, setTotalJumlah] = useState([])
    const [ppmKontainer, setPpmKontainer] = useState([])
    const [ppmMutu, setPpmMutu] = useState({})
    const [ppmMutuProd, setPpmMutuProd] = useState([])
    const [ppmMutuArea, setPpmMutuArea] = useState(null)
    const [detilIkan, setDetilIkan] = useState(null)
    const [ppmKemasan, setPpmKemasan] = useState([])
    const [isFormLama, setIsFormLama] = useState(false)

    const fetchAllData = useCallback(async () => {
        if (!datappm?.nomorAju || !dataDisposisi?.noTugas) {
            console.warn("datappm atau dataDisposisi belum tersedia");
            return;
        }

        try {
            const jsonMutuPK = {
                nomorAju: datappm.nomorAju,
                noProses: dataDisposisi.noTugas
            };

            const jsonPelMuat = {
                jnsPelabuhan: "D",
                kodePelabuhan: datappm.pelabuhanMuat
            };

            const jsonPelBongkar = {
                jnsPelabuhan: "L",
                kodePelabuhan: datappm.pelabuhanBongkar
            };

            const results = await Promise.allSettled([
                transaksiService.getHcMutuById(jsonMutuPK),
                userService.getUptById(datappm.kdUpt),
                masterService.getNegaraById(datappm.negaraPartner),
                masterService.getPelabuhanById(JSON.stringify(jsonPelMuat)),
                masterService.getPelabuhanById(JSON.stringify(jsonPelBongkar)),
                transaksiService.listPpmDetilAll(datappm.nomorAju),
                transaksiService.getTotalJumlahKomoditiPerSatuan(datappm.nomorAju),
                transaksiService.listPpmKemasanAll(datappm.nomorAju),
                transaksiService.listPpmContainerAll(datappm.nomorAju),
                transaksiService.getPpmMutuById(datappm.nomorAju),
                transaksiService.listPpmMutuProdAll(datappm.nomorAju),
                transaksiService.listPpmMutuAreaAll(datappm.nomorAju)
            ])

            const [
                resHc,
                resUpt,
                resNeg,
                resPelMuat,
                resPelBongkar,
                resDetil,
                resTotal,
                resKemasanAll,
                resKontainer,
                resMutu,
                resMutuProd,
                resMutuArea
            ] = results

            const getData = (res, fallback = []) =>
                res.status === "fulfilled"
                    ? res.value?.data?.data ?? res.value?.data ?? fallback
                    : fallback;

            // Update state (batched oleh React)
            setDataHc(getData(resHc));
            setUpt(getData(resUpt, {}));
            setNegaraTujuan(getData(resNeg, {}))
            setPelMuat(getData(resPelMuat, {}));
            setPelBongkar(getData(resPelBongkar, {}));
            setPpmDetil(getData(resDetil));
            setTotalJumlah(getData(resTotal));
            setPpmKemasan(getData(resKemasanAll));
            setPpmKontainer(getData(resKontainer));
            setPpmMutu(getData(resMutu, {}));
            setPpmMutuProd(getData(resMutuProd));
            setPpmMutuArea(getData(resMutuArea));

            resDetil.value.data.data.map(async (dtl, index) => {
                let resIdIkan = await masterService.getMasterIkanById(dtl.idIkan)
                setDetilIkan(resIdIkan.data)
            })

            const batasTanggal = '2025-07-01'
            if (new Date(resHc.data.tglHc) < new Date(batasTanggal)) {
                setIsFormLama(true)
            }
        } catch (error) {

        }
    }, [datappm, dataDisposisi, transaksiService, masterService, userService])

    useEffect(() => {
        let isMounted = true;
        if (!datappm) return;

        const loadData = async () => {
            try {
                await fetchAllData();
            } catch (e) {
                if (isMounted) console.error(e);
            }
        };

        loadData();

        return () => { isMounted = false; };
    }, [datappm, fetchAllData]);

    return (
        <Document>
            <Page size="LEGAL" style={styles.page}>
                <View style={styles.sectionHeader} fixed>
                    <View>
                        <Text style={styles.textRefNo}>证书号 / Num.Ref : {dataHc !== null ? dataHc.noHcMutu : ''}</Text>
                    </View>
                    <View style={styles.table}>
                        <View style={[styles.tableRow, { backgroundColor: '#D3D3D3' }]}>
                            <Text style={styles.textCnBold}>I. 主管当局信息 Information of competent authority</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCon1}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textCn}>输出国 Country of export : </Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableCon2}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEn}>THE REPUBLIC OF INDONESIA</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCon1}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textCn}>生产国 Country of production : </Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableCon2}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEn}>INDONESIA</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCon1}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textCn}>主管当局 Competent authority : </Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableCon2}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEn}>MARINE AND FISHERIES QUALITY ASSURANCE AGENCY (MFQAA)</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCon1}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textCn}>发证部门 Department of certificate issuance : </Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableCon2}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEn}>{upt !== null ? upt.nmInggris : ''}</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.table, { borderTop: 0 }]}>
                        <View style={[styles.tableRow, { backgroundColor: '#D3D3D3' }]}>
                            <Text style={styles.textCnBold}>II. 水产品信息 Identification of the fishery products</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCon1}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textCn}>商品名称 Commodity Name : </Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableCon2}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEn}>
                                        {
                                            ppmDetil.length <= 3 ?
                                                (
                                                    ppmDetil.map((detil, index) => {
                                                        return <>{detil.namaLokal}{index < ppmDetil.length - 1 ? '; ' : ''}</>
                                                    })
                                                ) :
                                                (
                                                    'See Appendix'
                                                )
                                        }
                                    </Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCon1}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textCn}>学名 Scientific name : </Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableCon2}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textIn}>
                                        {
                                            ppmDetil.length <= 3 ?
                                                (
                                                    ppmDetil.map((detil, index) => {
                                                        return <>{detil.namaLatin}{index < ppmDetil.length - 1 ? '; ' : ''}</>
                                                    })
                                                ) :
                                                (
                                                    'See Appendix'
                                                )
                                        }
                                    </Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCon1}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textCn}>包装数量 Number of packages : </Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableCon2}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEn}>
                                        {
                                            ppmKemasan !== null && ppmKemasan.map((kms, idx) => {
                                                return (
                                                    <>{kms.jumlah} <Kemasan id={kms.kodeKemasan} />{idx < ppmKemasan.length - 1 ? '; ' : ''}</>
                                                )
                                            })
                                        }
                                    </Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCon1}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textCn}>净重 Net Weight : </Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableCon2}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    {/* <Text style={styles.textEn}>{dataHc !== null ? dataHc.netto : ''} KGS</Text> */}
                                    <Text style={styles.textEn}>
                                        {/* {dataHc !== null ? dataHc.netto : ''} kgs */}
                                        {
                                            totalJumlah.map((detil, index) => {
                                                return (
                                                    detil.kodeSatuan.toUpperCase() === 'KGM' ?
                                                        formatNumberUSFormat(detil.totalJumlah) + ' ' + detil.kodeSatuan.toUpperCase() :
                                                        formatNumberUSFormat(detil.totalJumlah) + ' ' + detil.kodeSatuan.toUpperCase() + ' = ' + formatNumberUSFormat(detil.totalNetto) + ' KGM'
                                                )
                                            })
                                        }
                                    </Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.table, { borderTop: 0 }]}>
                        <View style={[styles.tableRow, { backgroundColor: '#D3D3D3' }]}>
                            <Text style={styles.textCnBold}>III. 水产品來源 Origin of the fishery products</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCon1}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textCn}>原料原产國 Country of origin of raw materials : </Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableCon2}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEn}>Indonesia</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCon1}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textCn}>加工方式 Processing Type : </Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableCon2}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEn}>{ppmMutu !== null ? ppmMutu.mutuProses : ''}</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.table, { borderTop: 0 }]}>
                        <View style={styles.tableRow}>
                            <Text style={styles.textCn}>生产方式 Production mode :</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCon1}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textCn}>养殖 Aquacultured : </Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableCon2}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textCn}>是 Yes</Text>
                                {
                                    ppmMutuArea !== null && ppmMutuArea[0].mutuArea === '1' ?
                                        (
                                            <Image src={imgCheckBoxIcon} style={styles.checkicon} />
                                        ) :
                                        (
                                            <Image src={imgCheckBoxOutline} style={styles.checkicon} />
                                        )
                                }
                                <Text style={styles.textCn}>否 No</Text>
                                {
                                    ppmMutuArea !== null && ppmMutuArea[0].mutuArea === '1' ?
                                        (
                                            <Image src={imgCheckBoxOutline} style={styles.checkicon} />
                                        ) :
                                        (
                                            <Image src={imgCheckBoxIcon} style={styles.checkicon} />
                                        )

                                }
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCon1}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textCn}>野生捕捞 Wild Caught : </Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableCon2}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textCn}>是 Yes</Text>
                                {
                                    ppmMutuArea !== null && ppmMutuArea[0].mutuArea === '2' ?
                                        (
                                            <Image src={imgCheckBoxIcon} style={styles.checkicon} />
                                        ) :
                                        (
                                            <Image src={imgCheckBoxOutline} style={styles.checkicon} />
                                        )
                                }
                                <Text style={styles.textCn}>否 No</Text>
                                {
                                    ppmMutuArea !== null && ppmMutuArea[0].mutuArea === '2' ?
                                        (
                                            <Image src={imgCheckBoxOutline} style={styles.checkicon} />
                                        ) :
                                        (
                                            <Image src={imgCheckBoxIcon} style={styles.checkicon} />
                                        )
                                }
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCon1}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textCn}>生产水域性质 Character of productive water area : </Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableCon2}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textCn}>淡水 Fresh Water</Text>
                                {
                                    detilIkan !== null && detilIkan.tawar === 'T' ?
                                        <Image src={imgCheckBoxIcon} style={styles.checkicon} />
                                        :
                                        <Image src={imgCheckBoxOutline} style={styles.checkicon} />
                                }
                                <Text style={styles.textCn}>海水 Sea water</Text>
                                {
                                    detilIkan !== null && detilIkan.tawar === 'L' ?
                                        <Image src={imgCheckBoxIcon} style={styles.checkicon} />
                                        :
                                        <Image src={imgCheckBoxOutline} style={styles.checkicon} />
                                }
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCon1}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textCn}>养殖区域 Aquaculture area : </Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableCon2}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEn}>{ppmMutuArea !== null && ppmMutuArea[0].mutuArea === '1' ? <><KotaKab id={ppmMutuArea[0].mutuCultKota} />, <Propinsi id={ppmMutuArea[0].mutuCultProp} /></> : '***'}</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCon1}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textCn}>养殖场名称和原料原产国官方批准的注册编号 Aquaculture farm name and registration
                                        number approved by Country of origin of raw materials : </Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableCon2}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEn}>{ppmMutuArea !== null && ppmMutuArea[0].mutuArea === '1' ? ppmMutuArea[0].mutuBudidayaNama : '***'}</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCon1}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textCn}>捕捞区域 Catching area : </Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableCon2}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textIn}>{ppmMutuArea !== null && ppmMutuArea[0].mutuArea === '2' ? ppmMutuArea[0].mutuTangkapArea : '***'}</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCon1}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textCn}>捕捞渔船船名, 注册编号和船籍 Name of Fishing Vessel, Registration Number and Flag of the Vessel : </Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableCon2}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEn}>{ppmMutuArea !== null && ppmMutuArea[0].mutuArea === '2' ? ppmMutuArea[0].mutuTangkapKapal : '***'}</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCon1}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textCn}>捕捞加工渔船船名, 注册编号和船籍 Name of Fishing and Factory Vessel, Registration Number and Flag of the Vessel : </Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableCon2}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEn}>{ppmMutuArea !== null && ppmMutuArea[0].mutuArea === '2' ? ppmMutuArea[0].mutuTangkapKapal : '***'}</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCon1}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textCn}>运输渔船船名, 注册编号和船籍 Name of Transport Fishing Vessel, Registration Number and Flag of the Vessel : </Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableCon2}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEn}>{ppmMutuArea !== null && ppmMutuArea[0].mutuArea === '2' ? ppmMutuArea[0].mutuTangkapKapal : '***'}</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCon1}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textCn}>原料存放独立冷库名称, 注册编号和所属国 Name of Independent cold storage for raw materials, Registration number and host country of the Storage : </Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableCon2}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEn}>{dataHc !== null ? dataHc.nmUpi : ''}</Text>
                                    <Text style={styles.textEn}>{dataHc !== null ? dataHc.noRegUpi : ''}</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    {
                        isFormLama &&
                        <View style={styles.tableRow}>
                            <View style={styles.tableCon1}>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableColBoxCon1}>
                                        <Text style={styles.textCn}>成品存放独立冷库名称、注册编号和所属国 Name of Independent cold storage for products, Registration number and host country of the Storage: </Text>
                                    </View>
                                </View>
                            </View>
                            <View style={styles.tableCon2}>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableColBoxCon1}>
                                        <Text style={styles.textEn}>{dataHc !== null ? dataHc.nmUpi : ''}</Text>
                                        <Text style={styles.textEn}>{dataHc !== null ? dataHc.noRegUpi : ''}</Text>
                                    </View>
                                </View>
                            </View>
                        </View>
                    }
                    <View style={styles.tableRow}>
                        <View style={styles.tableCon1}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textCn}>加工厂厂名和注册编号 Name of Processing Plant & Registration number of the Plant : </Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableCon2}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEn}>{dataHc !== null ? dataHc.nmUpi : ''}</Text>
                                    <Text style={styles.textEn}>{dataHc !== null ? dataHc.noRegUpi : ''}</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCon1}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textCn}>生产日期 Production Date : </Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableCon2}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEn}>
                                        {
                                            ppmMutuProd !== null && ppmMutuProd.map((mutuProd, index) => {
                                                return (
                                                    <Text key={index} style={[styles.text]}>
                                                        {mutuProd.mutuProdTgl}{index < ppmMutuProd.length - 1 ? ', ' : ''}
                                                    </Text>
                                                )
                                            })
                                        }
                                    </Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCon1}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textCn}>生产批号 Lot No. of products : </Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableCon2}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEn}>
                                        {
                                            ppmMutuProd !== null && ppmMutuProd.map((mutuProd, index) => {
                                                return (
                                                    <Text key={index} style={[styles.text]}>
                                                        {mutuProd.mutuProdNo}{index < ppmMutuProd.length - 1 ? ', ' : ''}
                                                    </Text>
                                                )
                                            })
                                        }
                                    </Text>
                                </View>
                            </View>
                        </View>
                    </View>
                </View>
            </Page>
            <Page size="LEGAL" style={styles.pageTwo}>
                <View style={styles.sectionHeader} fixed>
                    <View>
                        <Text style={styles.textRefNoCn}>证书号 / Num.Ref : {dataHc !== null ? dataHc.noHcMutu : ''}</Text>
                    </View>
                    <View style={styles.table}>
                        <View style={[styles.tableRow, { backgroundColor: '#D3D3D3' }]}>
                            <Text style={styles.textCnBold}>IV. 运输信息 Information of Transport</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCon1}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textCn}>发货人名称及地址 Name and address of Consignor : </Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableCon2}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEn}>{dataHc !== null ? dataHc.nmPengirim : ''}</Text>
                                    <Text style={styles.textEn}>{dataHc !== null ? dataHc.alPengirim : ''}</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCon1}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textCn}>收货人名称及地址 Name and address of Consignee : </Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableCon2}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEn}>{dataHc !== null ? dataHc.nmPenerima : ''}</Text>
                                    <Text style={styles.textEn}>{dataHc !== null ? dataHc.alPenerima : ''}</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCon1}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textCn}>发货地 Place of dispatch production : </Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableCon2}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEn}>{pelMuat !== null ? pelMuat.uraianPelabuhan : ''}</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCon1}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textCn}>目的地 Place of destination : </Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableCon2}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEn}>{pelBongkar !== null ? pelBongkar.uraianPelabuhan : ''}, {negaraTujuan !== null ? negaraTujuan.uraianNegara : ''}</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCon1}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textCn}>运输工具信息 Means of transport : </Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableCon2}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEn}>{dataHc !== null ? (dataHc.jnsTrans === '1' ? <>Vessel / Ship</> : <>By Plane</>) : ''}</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCon1}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textCn}>船只名称 Name of Vessel : </Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableCon2}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                <Text style={styles.textEn}>{dataHc !== null && dataHc.jnsTrans === '1' ? <>{dataHc.nmTrans} / Voyage : {dataHc.noFlight}</> : '***'}</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCon1}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textCn}>航班号 Flight Number : </Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableCon2}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                <Text style={styles.textEn}>{dataHc !== null && dataHc.jnsTrans === '3' ? <>{dataHc.nmTrans} / {dataHc.noFlight}</> : '***'}</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCon1}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textCn}>其他运输工具信息 other transport means : </Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableCon2}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEn}>***</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCon1}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textCn}>集装箱号 Container Number : </Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableCon2}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEn}>
                                        {
                                            ppmKontainer !== undefined && ppmKontainer !== null &&
                                            ppmKontainer.map((kont, index) => {
                                                return (
                                                    <>
                                                        {kont.nomor}{index < ppmKontainer.length - 1 ? '; ' : ''}
                                                    </>
                                                )
                                            })
                                        }
                                    </Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCon1}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textCn}>封识号 Seal Number : </Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableCon2}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textEn}>
                                        {
                                            ppmKontainer !== undefined && ppmKontainer !== null &&
                                            ppmKontainer.map((kont, index) => {
                                                return (
                                                    <>
                                                        {kont.nomorSegel}{index < ppmKontainer.length - 1 ? '; ' : ''}
                                                    </>
                                                )
                                            })

                                        }
                                    </Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCon1}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textCn}>启运日期 Date of departure : </Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableCon2}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textEn}>{dataHc !== null ? formatDateStringLocalDate(dataHc.tglBerangkat) : ''}</Text>
                            </View>
                        </View>
                    </View>
                    <View style={styles.table}>
                        <View style={[styles.tableRow, { backgroundColor: '#D3D3D3' }]}>
                            <Text style={styles.textCnBold}>V. 健康声明 Health Attestation</Text>
                        </View>
                    </View>
                    <View style={[styles.table, { borderTop: 0 }]}>
                        <View style={styles.tableRow}>
                            <Text style={styles.textCn}>兹证明 This is to certify that :</Text>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColBox2}>
                                <Text style={styles.textCnAtt}>1.</Text>
                            </View>
                            <View style={styles.tableColBoxAtt}>
                                <Text style={styles.textCnAtt}>该产品在主管当局推荐在华注册的捕捞渔船, 运输渔船, 捕捞加工渔船, 独立冷库和加工企业 捕捞, 加工, 包装, 储存和运输。 The products have been caught, processed, packaged, stored and transported in fishing vessels, transport fishing vessels, fishing and factory vessels, independent cold storages and processing plants, which are registered in China recommended by the Competent Authority</Text>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColBox2}>
                                <Text style={styles.textCnAtt}>2.</Text>
                            </View>
                            <View style={styles.tableColBoxAtt}>
                                <Text style={styles.textCnAtt}>该产品在卫生条件下生产, 包装, 储藏和运输, 并置于主管当局监督之下。The products were produced, packed, stored, and transported under sanitary condition, which were under the supervision of competent authority.</Text>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColBox2}>
                                <Text style={styles.textCnAtt}>3.</Text>
                            </View>
                            <View style={styles.tableColBoxAtt}>
                                <Text style={styles.textCnAtt}>该产品经主管当局检验检疫, 未发现中国规定的致病微生物, 有毒有害物质和 异物, 及中国和OIE所列的疫病。The products were inspected and quarantined by competent authority and not found any diseases, pathogenic microorganism, harmful substances and foreign substances regulated in the P.R.China and the diseases listed by China and OIE.</Text>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColBox2}>
                                <Text style={styles.textCnAtt}>4.</Text>
                            </View>
                            <View style={styles.tableColBoxAtt}>
                                <Text style={styles.textCnAtt}>该产品符合兽医卫生要求, 适合人类食用。The products meet veterinary sanitary requirements and are fit for human consumption.</Text>
                            </View>
                        </View>
                        {
                            isFormLama &&
                            <>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableColBox2}>
                                        <Text style={styles.textCnAtt}>5.</Text>
                                    </View>
                                    <View style={styles.tableColBoxAtt}>
                                        <Text style={styles.textCnAtt}>证书中所载的养殖场, 加工厂, 捕捞渔船, 捕捞加工渔船, 运输船, 独立冷库均能按照联合国粮农组织和世界卫生组织发布的 《新冠肺炎和食品安全:对食品企业指南》,建立有效的食品安全管理体系, 做好各项防控措施, 确保输华产品未被新冠病毒污染。The aquaculture farm, processing plant, fish vessel, fish and factory vessel, transport vessel and independent cold storage in the certificate have established effective food safety management system according to the COVID-19 and food safety: guidance for businesses announced by FAO/WHO, and enact all kinds of protective measures to ensure that the products are not polluted by the Covid-19 virus.</Text>
                                    </View>
                                </View>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableColBox2}>
                                        <Text style={styles.textCnAtt}>6.</Text>
                                    </View>
                                    <View style={styles.tableColBoxAtt}>
                                        <Text style={styles.textCnAtt}>该产品和装运该批货物的运输工具内壁已在主管当局监督下实施了针对新冠病毒的预防性消毒。The products and inner wall of the means of transport carrying these products were carried out disinfection to prevent COVID-19 under the supervision of competent authority.</Text>
                                    </View>
                                </View>
                            </>
                        }
                    </View>
                    <View style={styles.tableRow}>
                        <View style={styles.tableCon1}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textCn}>签发地点 Place of Issue : </Text>
                                <Text style={styles.textEn}>{upt !== null ? upt.kota : ''}</Text>
                            </View>
                        </View>
                        <View style={styles.tableCon2}>
                            <View style={styles.tableRow}>
                                <Text style={styles.textCn}>签发日期 Date of Issue : </Text>
                                <Text style={styles.textEn}>{dataHc !== null ? formatDateStringLocalDate(dataHc.tglHc) : ''}</Text>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCon1, { borderRight: 0 }]}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textCn}>官方印章 Official Stamp : </Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableCon2}>
                            <View style={styles.tableRow}>
                                <View style={styles.tableColBoxCon1}>
                                    <Text style={styles.textCn}>官方兽医签字 Official Veterinary Signature</Text>
                                </View>
                            </View>
                            <View style={styles.tableColBoxCon1}>
                                <View style={[styles.tableCol, { marginTop: 60, marginBottom: 10 }]}>
                                    <Text style={[styles.textEn, { textAlign: "center" }]}>{dataHc !== null ? dataHc.nmPejabat : ''}</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.table, { borderTop: 0 }]}>
                        <View style={styles.tableRow}>
                            <Text style={styles.textCnAtt}>i填写说明 Introduction for filling :</Text>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColBox2}>
                                <Text style={styles.textCnAtt}>1.</Text>
                            </View>
                            <View style={styles.tableColBoxAtt}>
                                <Text style={styles.textCnAtt}>生产国是指产品完成最后一道外包装工序的所在国。Country of production is refer to the country where the last outer packing procedure of the product was completed.</Text>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColBox2}>
                                <Text style={styles.textCnAtt}>2.</Text>
                            </View>
                            <View style={styles.tableColBoxAtt}>
                                <Text style={styles.textCnAtt}>加工方式是指冰鲜, 冷冻, 干制, 盐渍, 熏制, 罐装等。Processing Type is refer to Chilled, Frozen, Dried, Salted, Smoked, Canned.</Text>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColBox2}>
                                <Text style={styles.textCnAtt}>3.</Text>
                            </View>
                            <View style={styles.tableColBoxAtt}>
                                <Text style={styles.textCnAtt}>输出国主管部门应完整填写从捕捞, 加工, 包装, 存储, 运输和出口等全过程中涉及的原料原产国, 产品生产国和证书签发国的企业信息, 包括加工厂, 捕捞渔船, 捕捞加工渔船, 运输渔船和独立冷库的名称和对华注册编号, 不得遗漏上述任何环节中涉及的企业信息。The competent authority of the exporting country fill in the establishments information of country of origin of raw material, country of production and country of certificates involved in the whole process of fishing, processing, packaging, storage, transportation and export, including the names and registration numbers of processing plants, fishing vessels, fishing and factory vessels, transport fishing vessels and independent cold storage. The establishments information involved in any of the above links shall not be omitted.</Text>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={styles.tableColBox2}>
                                <Text style={styles.textCnAtt}>4.</Text>
                            </View>
                            <View style={styles.tableColBoxAtt}>
                                <Text style={styles.textCnAtt}>此证书内容不适用部分以***填充。If any of the information required is not applicable, then the blank area must be filled with ***</Text>
                            </View>
                        </View>
                    </View>
                </View>
            </Page>
            {
                ppmDetil.length > 1 &&
                <>
                    <DraftAppendix ppmdetil={ppmDetil} datahc={dataHc} upt={upt} dataDisposisi={dataDisposisi} qrImage={qrImage} ppmMutuProd={ppmMutuProd} finalFor="2"/>
                </>
            }
        </Document>
    )
}

export default FormB